function leaseSearchModalTarget(href) {
  const raw = String(href || '').trim();
  if (!raw) return null;
  let url;
  try {
    url = new URL(raw, 'https://pixie.bigtapapp.com');
  } catch {
    return null;
  }
  const path = url.pathname.replace(/\/+$/, '');
  if (!/\/lease-search$/i.test(path)) return null;
  const search = url.searchParams.get('search') || '';
  const match = search.match(/^:\s*(\d+)$/);
  if (!match) return null;
  const leaseId = match[1];
  const query = new URLSearchParams({
    search: `:${leaseId}`,
    hideNav: '1',
  });
  return {
    leaseId,
    src: `/lease-search?${query.toString()}`,
  };
}

function leaseSearchMarkdownLink(leaseId, address) {
  const id = String(leaseId ?? '').trim();
  if (!/^\d+$/.test(id)) return '';
  const title = String(address ?? '')
    .trim()
    .replace(/"/g, '');
  const url = `https://pixie.bigtapapp.com/lease-search?search=:${id}&hideNav=1`;
  return title ? `[${id}](${url} "${title}")` : `[${id}](${url})`;
}

module.exports = {
  leaseSearchModalTarget,
  leaseSearchMarkdownLink,
};
